<template>
    <keep-alive>
    <div class="row mt-4 table-low-res">

        <div class="col-md-12">


            <table class="tables w-100 mb-4">
                <tr>
                    <th class="text-center">Fila de atendimento</th>
                    <th class="text-center">CNPJ</th>
                    <th class="text-center">Cliente</th>
                    <th class="text-center">Data de Abertura</th>
                    <th class="text-center">Ver Mais</th>
                </tr>
                <tr v-for="el in sortedResults" :key='el.id' :class="{'visto': el.visto == 1}" >
                    <td class="text-center">{{el.queue}}</td>
                    <td class="text-center">{{el.cpf_cnpj}}</td>
                    <td class="text-center">{{(el.client) ? el.client.fantasy_name : ''}}</td>
                    <td class="text-center">{{formatDate(el.created_at)}}</td>
                    <td class="text-center" v-if="el.type == 'telefonia'"> - </td>
                    <td class='show-plus' v-else><button class='no-border' @click.prevent="el.visto = 1;findLogById(el.uniqueid)" > <img class='img img-table text-center' src='/imgs/icons/eye.svg'> </button></td>
                </tr>

            </table>
            <button class="button-page btn btn-light" @click="nextPage">Proximo</button>
            <button class="button-page btn btn-light" @click="prevPage">Anterior</button> 
        </div>
    </div>

    </keep-alive>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    data(){
        return{
            obj: [],
            currentSort:'created_at',
            currentSortDir:'asc',
            pageSize:10,
            currentPage:1
        }
    },
    computed:{
    ...mapGetters(['getAllOcorrence', 'oneClient','getAllOcorrence']),
 
    sortedResults:function() {
        return this.obj.sort((a,b) => {
            let modifier = 1;
            if(this.currentSortDir === 'desc') modifier = -1;
            if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
            return 0;
        }).filter((row, index) => {
            let start = (this.currentPage-1)*this.pageSize;
            let end = this.currentPage*this.pageSize;
            if(index >= start && index < end) return true;
        });
    
    }
	},
    methods:{
        ...mapActions(['fetchOcurrences', 'findLogById', 'receivelog']),

        formatDate(stringDate){
            let p = stringDate.split(/\D/g)
            let date = [p[2],p[1],p[0] ].join("/")
            let time = stringDate.split(/\s(.+)/g)[1]

            return `${date} ${time}`;
        },
        nextPage:function() {
            if((this.currentPage*this.pageSize) < this.obj.length) this.currentPage++;
        },
        prevPage:function() {
            if(this.currentPage > 1) this.currentPage--;
        }
    },
    mounted(){
        this.receivelog();
    },
    watch:{

        oneClient: function(){
	    if(this.oneClient){
           
            axios.get('/getAttendanceByCNPJ', {params:{
                cnpj: this.oneClient.cpf
            }}).then(data => {
                this.fetchOcurrences(data.data)
                this.obj = data.data
            });
	    }else{
		    this.obj = [];
	    }
            
            // let cnpj = this.$store.getters.oneClient.cpf_cnpj
        },
        getAllOcorrence: function(){
            this.obj = this.getAllOcorrence
        }
    },
}
</script>

<style scoped>
    .visto >>> td{
        background-color:rgba(191, 191, 191, 1);
    }
    tr:hover{
        background-color: rgba(170, 170, 170, 1);
    }
    td:hover{
        background-color: rgba(191, 170, 170, 1);
    }
    .button-page{
        float:right;
        margin-right: 0.5em;
    }
    .no-border{
        border: hidden;
        background: none;
    }
    /* .img{
        height:4em;
    } */
    /*
	@media screen and (max-height: 760px) {
        .table-low-res{
            height: 21em;
            overflow: auto;
        }
    }
    */
	@media screen and (max-width: 1489px) {
		
        .table-low-res{
            height: 33em;
            overflow: auto;
        }

	}
    @media screen and (max-width: 941px){
        .table-low-res{
            height: 30em;
            overflow: auto;
        }
    }
</style>
